// Storage keys for onboarding state
const COPARENT_INVITE_SKIPPED_KEY = 'cp.onboarding.coparent_invite_skipped';

// Investment step keys (engagement-only screens)
const ONBOARDING_WELCOME_DONE_KEY = 'cp.onboarding.welcome_done';
const ONBOARDING_SOCIAL_PROOF_DONE_KEY = 'cp.onboarding.social_proof_done';
const ONBOARDING_GOALS_DONE_KEY = 'cp.onboarding.goals_done';
const ONBOARDING_SITUATION_DONE_KEY = 'cp.onboarding.situation_done';
const ONBOARDING_CHILDREN_COUNT_DONE_KEY = 'cp.onboarding.children_count_done';
const ONBOARDING_CURRENT_TOOLS_DONE_KEY = 'cp.onboarding.current_tools_done';
const ONBOARDING_PAIN_POINT_DONE_KEY = 'cp.onboarding.pain_point_done';

export function getCoparentInviteSkipped(): boolean {
  return localStorage.getItem(COPARENT_INVITE_SKIPPED_KEY) === '1';
}

export function setCoparentInviteSkipped(skipped: boolean) {
  if (skipped) {
    localStorage.setItem(COPARENT_INVITE_SKIPPED_KEY, '1');
  } else {
    localStorage.removeItem(COPARENT_INVITE_SKIPPED_KEY);
  }
}

// Investment step helpers
export function getOnboardingStepDone(step: string): boolean {
  const key = getStepKey(step);
  return key ? localStorage.getItem(key) === '1' : false;
}

export function setOnboardingStepDone(step: string) {
  const key = getStepKey(step);
  if (key) {
    localStorage.setItem(key, '1');
  }
}

export function areInvestmentStepsDone(): boolean {
  return (
    getOnboardingStepDone('welcome') &&
    getOnboardingStepDone('social_proof') &&
    getOnboardingStepDone('goals') &&
    getOnboardingStepDone('situation') &&
    getOnboardingStepDone('children_count') &&
    getOnboardingStepDone('current_tools') &&
    getOnboardingStepDone('pain_point')
  );
}

/** Returns the route path for the first incomplete investment step, or null if all done. */
export function getFirstIncompleteInvestmentStep(): string | null {
  const steps: { key: string; route: string }[] = [
    { key: 'welcome', route: '/app/onboarding/welcome' },
    { key: 'social_proof', route: '/app/onboarding/social-proof' },
    { key: 'goals', route: '/app/onboarding/goals' },
    { key: 'situation', route: '/app/onboarding/situation' },
    { key: 'children_count', route: '/app/onboarding/children-count' },
    { key: 'current_tools', route: '/app/onboarding/current-tools' },
    { key: 'pain_point', route: '/app/onboarding/pain-point' },
  ];
  for (const step of steps) {
    if (!getOnboardingStepDone(step.key)) {
      return step.route;
    }
  }
  return null;
}

function getStepKey(step: string): string | null {
  const map: Record<string, string> = {
    welcome: ONBOARDING_WELCOME_DONE_KEY,
    social_proof: ONBOARDING_SOCIAL_PROOF_DONE_KEY,
    goals: ONBOARDING_GOALS_DONE_KEY,
    situation: ONBOARDING_SITUATION_DONE_KEY,
    children_count: ONBOARDING_CHILDREN_COUNT_DONE_KEY,
    current_tools: ONBOARDING_CURRENT_TOOLS_DONE_KEY,
    pain_point: ONBOARDING_PAIN_POINT_DONE_KEY,
  };
  return map[step] ?? null;
}
